export default {
  'environments.title': 'Manage Environments',
};
